import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Role {
  CreateDate: string;
  role_id: string;
  Role: string;
  Role_Description: string;
  assigned_user: string | null;
  SID: string;
  Table: string;
  Value: string;
  Schema: string;
  ColumnName: string;
}

interface RolesState {
  rolesData: Role[];
}

const initialState: RolesState = {
  rolesData: [],
};

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {
    setRolesData(state, action: PayloadAction<Role[]>) {
      state.rolesData = action.payload;
    },
    updateAssignedUser(state, action: PayloadAction<{ roleId: string; users: string[] }>) {
      const { roleId, users } = action.payload;
      const role = state.rolesData?.find((r) => r.role_id === roleId);
      if (role) {
        role.assigned_user = users.join(', ');
      }
    },
  },
});

export const { setRolesData, updateAssignedUser } = rolesSlice.actions;
export default rolesSlice.reducer;
